
import { config } from '../../../src/Config';
import FpgNav from './fpg/Nav.vue';
import FpgInfo from './fpg/Info.vue';
import {PropType} from 'vue';
import {Page, PageIdentity} from '../../../src/Entity/Page';
import {PageItemInterface} from '../../../src/Entity';

export default {
    components: { FpgNav, FpgInfo },
    props: {
        item: {
            type: Object as PropType<PageItemInterface>,
            required: true,
        },
        pageIdentity: {
            type: Object as PropType<PageIdentity>,
            required: true,
        },
        isAdaptive: {
            type: Boolean,
            default: false
        },
    },
    emits: ['applyFilter'],
    methods: {
        emptyImagePreviewPassport() {
            return config.emptyImagePreviewPassport;
        },
        onApplyFilter(identity, ...args) {
            this.$emit('applyFilter', identity, ...args);
        },
        routeParams(): any {
            return {itemId: this.item.id, ...this.pageIdentity};
        },
    },
};
